module.exports = __webpack_public_path__ + "img/briefcase.66307d98.svg";